module.exports = __webpack_public_path__ + "static/media/rpa.7c3ece2b.svg";